import React, { useState, useEffect, useRef } from 'react';
import { Navbar, Container } from 'react-bootstrap';
import Logo from "../../../assets/landing_pageV1/coschoollogo.svg";
import HamburgerOpen from '../../../assets/krishna-ai/burgerIcon.svg';
import HamburgerClose from '../../../assets/krishna-ai/dropdown.svg';
import styles from "./Topbar.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { ResourceHub_URL, routesLinks } from '../../../utils/RouteConstants';
import ActionButton from './ActionButton';
import FormModal from '../modals/FormModal';
import SchoolAiPage from '../../SchoolAiPage';
import headPhoneslogo from '../../../assets/landing_pageV1/headphones.svg';

const MENUS = [
    // { title: "Ai Assistant", path: routesLinks.teacher, isRoute: true },
    { title: "About Us", path: routesLinks.aboutus, isRoute: true },
    { title: "Careers", path: routesLinks.careers, isRoute: true },
    { title: "Resource Hub", path: ResourceHub_URL, isRoute: false }
];


export default function Topbar2({ handleBtnClick, showActionButton = false }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const menuRef = useRef(null);
    const navRef = useRef(null);
    const navigate = useNavigate();
    const [openSchoolForm, setOpenSchoolForm] = useState(false)
    const [darkNav, setDarkNav] = useState(false);

    useEffect(() => {
        let ticking = false;
        const update = () => {
            ticking = false;
            const nav = navRef.current;
            if (!nav) return;
            const r = nav.getBoundingClientRect();
            const probeY = r.top + r.height / 2;
            const darks = document.querySelectorAll('[data-nav-theme="dark"]');
            let isDark = false;
            for (const el of darks) {
                const er = el.getBoundingClientRect();
                if (er.top <= probeY && er.bottom >= probeY) {
                    isDark = true;
                    break;
                }
            }
            setDarkNav(isDark);
        };
        const onScroll = () => {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(update);
            }
        };
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, [location]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const handleNavigate = (path, isRoute) => {
        if (isRoute) {
            navigate(path);
        } else {
            window.open(path, "_blank", "noopener,noreferrer");
        }
    };

    useEffect(() => {
        if (location?.pathname == routesLinks.demoform) {
            setOpenSchoolForm(true);
        }
    }, [location])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) &&
                !event.target.closest(`.${styles.hamburgerMenu}`)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    const handleClose = () => {
        setOpenSchoolForm(false);
        navigate("/");
        setIsMenuOpen(false);
    }

    const handleLogoClick = () => {
        if (openSchoolForm) {
            setOpenSchoolForm(false);
        }
        navigate("/");
    }


    return (
        <Navbar ref={navRef} className={`${styles.container} ${darkNav ? styles.darkNav : ''}`}>
            <Container fluid className={styles.navContainer}>
                <Navbar.Brand onClick={handleLogoClick} className={styles.navbrand} style={{
                    cursor: "pointer"
                }}>
                    <img src={darkNav ? '/assets/logo-white.svg' : Logo} alt="Logo" />
                </Navbar.Brand>

                <div className={styles.menusContainer}>
                    {MENUS?.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={styles.item}
                                onClick={() => handleNavigate(item?.path, item?.isRoute)}
                            >
                                {item?.title}
                            </div>
                        )
                    })}
                    <ActionButton title={'Enquire Now'} styleContainer={'enquirebutton'} handleBtnClick={handleBtnClick} icon={headPhoneslogo} direction="bottom" />
                </div>
                <div className={styles.hamburgerMenu} onClick={toggleMenu}>
                    {isMenuOpen ? <img src={HamburgerClose} alt="Menu" /> : <img src={HamburgerOpen} alt="Menu" />}
                </div>
                {isMenuOpen && (
                    <div className={styles.menuItems} ref={menuRef}>
                        {MENUS?.map((item, index) => {
                            return (
                                <div
                                    key={index} className={styles.item}
                                    onClick={() => handleNavigate(item?.path, item?.isRoute)}
                                >
                                    {item?.title}
                                </div>
                            )
                        })}
                        {showActionButton && <ActionButton title={'Enquire Now'} styleContainer={'enquiryBtn'} handleBtnClick={handleBtnClick} icon={headPhoneslogo} direction="bottom" />}
                    </div>
                )}
            </Container>
            {openSchoolForm &&
                <FormModal isOpen={openSchoolForm} onRequestClose={handleClose}>
                    <SchoolAiPage onClose={handleClose} />
                </FormModal>
            }
        </Navbar>
    );
}